__turbopack_context__.v({
  "line": "C7wLvG_line",
  "stopover": "C7wLvG_stopover",
});
